<template>
    <div class="custom-control custom-checkbox">
        <input
                :area-checked="checked"
                :checked="checked"
                :id="id"
                :value="value"
                @change="$emit('change', $event.target.checked)"
                @click="$emit('click', $event.target)"
                class="custom-control-input"
                type="checkbox"
                v-bind="$attrs"
        />
        <label :for="id" class="custom-control-label">
            <slot></slot>
        </label>
    </div>
</template>

<script>
  import UniqueIdentifierProviderFactory from '../../utilities/providers/UniqueIdentifierFactory'

  export default {
        inheritAttrs: false,
        data() {
            return {
                id: null
            }
        },
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            checked: {
                type: Boolean,
                required: false,
                default: false
            },
            value: {
                type: String,
                required: false
            }
        },
        mounted() {
            // If the id is passed in, set it, otherwise set the id for the component
            // so that the label and checkbox communicate
            this.id = this.$attrs && this.$attrs.id ? this.$attrs.id : UniqueIdentifierProviderFactory.Create()
        }
    }
</script>

<style scoped>
    label:hover {
        cursor: pointer !important;
    }
</style>
